"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitDatasetProductIndexing = void 0;
const routes_1 = require("../../routes");
const submitDatasetProductIndexing = (client) => async () => {
    await client.post(routes_1.ENDPOINTS.SUBMIT_DATASET_PRODUCT_INDEXING_TASK.applyParams());
};
exports.submitDatasetProductIndexing = submitDatasetProductIndexing;
